import { MB_CONFIG } from "../config";

export default {
    INDEX: () => axios.get(MB_CONFIG.API_URL + "/exports/invoices"),
    DOWNLOAD: (year, month) =>
        axios.get(`${MB_CONFIG.API_URL}/exports/invoices/${year}/${month}`, {
            responseType: "blob",
        }),
};
